<template>
  <a-modal
    :title="title"
    width="800px"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form-model
      ref="auditForm"
      :model="form"
      :rules="rules"
      class="form-body"
      layout="horizontal"
    >
      <a-form-model-item label="项目名称" prop="projectName">
        <a-input v-model="form.projectName" placeholder="请输入项目名称" />
      </a-form-model-item>

      <a-form-model-item label="项目描述" prop="projectDesc">
        <a-textarea
          v-model="form.projectDesc"
          placeholder="请输入项目描述"
          :auto-size="{ minRows: 3, maxRows: 8 }"
        />
      </a-form-model-item>

      <a-form-model-item label="项目需求" prop="demandDesc">
        <a-textarea
          v-model="form.demandDesc"
          placeholder="请输入项目需求"
          :auto-size="{ minRows: 3, maxRows: 8 }"
        />
      </a-form-model-item>

      <div class="item-box">
        <a-form-model-item label="所属类目1" prop="projectType1">
          <a-select
            @change="handleChange"
            style="width: 200px"
            v-model="form.projectType1"
          >
            <a-select-option
              v-for="el in typeListFather"
              :key="el.id"
              :value="el.id"
            >
              {{ el.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="所属类目2" prop="projectType2">
          <a-select style="width: 200px" v-model="form.projectType2" allowClear>
            <a-select-option
              v-for="el in typeListChild"
              :key="el.id"
              :value="el.id"
            >
              {{ el.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>

      <div class="item-box">
        <a-form-model-item label="预算" prop="projectBudget">
          <a-input-number
            v-model="form.projectBudget"
            :formatter="(value) => `${value}元`"
          />
        </a-form-model-item>
        <a-form-model-item
          label=""
          prop="isCounterOffer"
          style="margin-left: 20px"
        >
          <a-checkbox v-model="form.isCounterOffer"> 是否可议价 </a-checkbox>
        </a-form-model-item>
        <a-form-model-item label="完成时间" prop="expectTime">
          <a-date-picker
            v-model="form.expectTime"
            valueFormat="YYYY-MM-DD HH:mm:ss"
          />
        </a-form-model-item>
      </div>

      <a-form-model-item label="其他附件" prop="applyAttmIds">
        <VMultiUpload file-type-code="4005" v-model="form.applyAttmIds"
          ><a-button>上传</a-button></VMultiUpload
        >
      </a-form-model-item>
      <a-form-model-item ref="companyId" label="咨询企业" prop="companyId">
        <a-select
          v-model="form.companyId"
          :filter-option="false"
          placeholder="选择咨询企业"
        >
          <a-empty
            slot="notFoundContent"
            :image-style="{ height: '50px' }"
            description="您还未加入企业"
          />
          <a-select-option v-for="item in companyList" :key="item.id">
            {{ item.companyName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="联系人" prop="contactPerson">
        <a-input v-model="form.contactPerson" placeholder="请输入联系人" />
      </a-form-model-item>

      <a-form-model-item label="手机号" prop="contactPhone">
        <a-input v-model="form.contactPhone" placeholder="请输入手机号" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import VMultiUpload from "@/components/VMultiUpload.vue";
import {
  getEvaluationConsultInfo,
  serviceConsultCommit,
  typeListByPid,
  typeListByPidIsNull,
} from "@/api/counst.js";
import { mapGetters } from "vuex";
import { sendMobile } from "@/api/common.js";
import { message } from "ant-design-vue";

export default {
  components: {
    VMultiUpload,
  },
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确!"));
      } else {
        callback();
      }
    };
    return {
      confirmLoading: false,
      visible: false,
      typeListChild: [],
      typeListFather: [],
      title: "开发申请",
      rules: {
        projectName: {
          required: true,
          message: "请输入项目名称",
        },
        projectDesc: {
          required: true,
          message: "请输入项目描述",
        },
        demandDesc: {
          required: true,
          message: "请输入项目需求",
        },
        companyId: {
          required: true,
          message: "请选择企业",
        },
        contactPerson: {
          required: true,
          message: "请输入联系人",
        },
        contactPhone: [
          {
            required: true,
            message: "请填写手机号",
            trigger: "blur",
          },
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
      },
      form: {
        projectBudget: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["tenant", "companyList", "userInfo"]),
  },
  methods: {
    sendMobileCode() {
      const { contactPhone } = this.form;
      sendMobile(contactPhone).then(() => {
        this.$message.success("发送成功！");
      });
    },
    async loadTypeFather() {
      this.typeListFather = await typeListByPidIsNull();
    },

    async loadTypeChild(id) {
      this.typeListChild = await typeListByPid(id);
    },

    handleChange(e) {
      this.form = Object.assign({}, this.form, { projectType2: "" });
      this.loadTypeChild(e);
    },

    async handleOk() {
      const { form } = this;
      await this.$refs.auditForm.validate();
      this.confirmLoading = true;
      form.tenantId = this.tenant.id;
      //   form.companyId = this.companyId;
      form.certificationStatus = "1";
      let res = await serviceConsultCommit(form);
      console.log(res, "res---");
      if (res.code === "-1") {
        message.warning(res.msg);
        return;
      }
      this.$emit("ok");
      this.confirmLoading = false;
      this.handleCancel();
    },
    handleCancel() {
      this.visible = false;
      this.$refs.auditForm.resetFields();
    },
    async open(text = "免费咨询", data = {}) {
      console.log(this.tenant.id, "this.tenantId----");
      if (data.id) {
        this.form = await getEvaluationConsultInfo(data.id);
      }
      this.visible = true;
      this.title = text;
    },
  },
  mounted() {
    this.form.contactPerson = this.userInfo.realName || null;
    this.form.contactPhone = this.userInfo.phone || null;
    this.loadTypeFather();
  },
};
</script>

<style scoped lang="scss">
.form-body {
  .ant-form-item::v-deep {
    display: flex;
    .ant-form-item-label {
      width: 100px;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
}
.item-box {
  display: flex;
}
.verify-code {
  color: #ea0b06;
  text-align: center;
  cursor: pointer;
}
</style>
